<template>
    <div class="text-center">
        <Link @click.prevent="openFeedbackForm()" data-qa="feedback-link">Checkout issues?</Link>
        <SupportForm ref="modal"/>
    </div>
</template>

<script>
import * as Analytics from '@/Util/reporting.js';
import Link from '@/Components/Link.vue';
import SupportForm from '@/BuyNow/Components/Modals/SupportForm.vue';

export default {
    components: {
        Link,
        SupportForm
    },
    methods: {
        openFeedbackForm() {
            this.$refs.modal.openModal();

            Analytics.pushToDataLayer({
                event: 'click',
                attributes: {
                    section: 'Plan Overview',
                    action: 'Click button',
                    event_label: 'Checkout issues?',
                },
            });
        }
    }
};
</script>

<style lang="postcss" scoped>
</style>
